import { BudgetCategoryBase } from './base/budget-category-base';

export class BudgetCategory extends BudgetCategoryBase { }